
:host {
  display: block;
  width: 100%;
  height: 50%;
}
  